"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metamaskFactory = exports.MetamaskWallet = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _MetamaskContext = require("./MetamaskContext");
var _chains = require("@blockwell/chains");
var _executor = require("../../executor");
class MetamaskWallet {
  get events() {
    return this.context.events;
  }
  get state() {
    return this.context.state;
  }
  constructor(context, parameters) {
    (0, _defineProperty2.default)(this, "type", "metamask");
    (0, _defineProperty2.default)(this, "executeHandler", async (state, args) => {
      let executor = new _executor.EthExecutor(this.type, this.context.ethereum, this.parameters.contracts);
      return await executor.execute(state, args);
    });
    this.context = context;
    this.parameters = parameters;
  }
  checkConnection() {
    return this.context.checkConnection();
  }
  async connect() {
    await this.context.connect();
    return this.context.state;
  }
  getAccount() {
    return this.context.account;
  }
  requestNetwork(network) {
    return this.context.requestNetwork(network);
  }
  register(controller) {
    controller.addHandler("MetamaskWallet", "prepareWallet", this.context.prepare);
    controller.addHandler("MetamaskWallet", "preExecute", this.context.preExecute);
    controller.addHandler("MetamaskWallet", "execute", this.executeHandler);
  }
  unregister(controller) {
    controller.removeHandler("MetamaskWallet");
  }
  estimateGas(state, step, args) {
    let net = (0, _chains.getChain)(args.chainId);
    return _executor.EthExecutor.estimateGas({
      ext: this.context.ethereum,
      from: state.wallet.account
    }, state.dumbapp, step, args, net);
  }
  updateStatus(submission) {
    let executor = new _executor.EthExecutor(this.type, this.context.ethereum, this.parameters.contracts);
    return executor.updateStatus(submission);
  }
}
exports.MetamaskWallet = MetamaskWallet;
const metamaskFactory = exports.metamaskFactory = {
  type: "metamask",
  async createWallet(parameters, window) {
    let context = await (0, _MetamaskContext.getMetamaskContext)(window);
    return new MetamaskWallet(context, parameters);
  }
};
//# sourceMappingURL=MetamaskWallet.js.map